const lightPalette = {
  mode: 'light',
  primary: { main: '#211747' },
  secondary: { main: '#02a5a9' },
  error: { main: '#d32f2f', secondary: '#fff0f0' },
  warning: { main: '#ed6c02' },
  info: { main: '#0288d1' },
  success: { main: '#2e7d32', secondary: '#edf8ef' },
  background: { default: '#f3f3f9', paper: '#ffffff' },
  custom: {
    surfaceAlt: '#f5f5f5',
    // Terminal/logs panel — mode-invariant on purpose (always dark).
    terminalBg: '#1a1a2e',
    terminalText: '#d4d4d4',
    terminalKeyword: '#90caf9',
    terminalTextLine: '#e0e0e0',
    terminalAccentPurple: '#bb86fc',
    terminalAccentTeal: '#03dac6',
  },
};

const darkPalette = {
  mode: 'dark',
  primary: { main: '#b5a7e6' },
  secondary: { main: '#4fd1d5' },
  error: { main: '#f44336', secondary: '#3d1b24' },
  warning: { main: '#ffa726' },
  info: { main: '#29b6f6' },
  success: { main: '#66bb6a', secondary: '#153622' },
  background: { default: '#0f0d1a', paper: '#1a1729' },
  custom: {
    surfaceAlt: '#252140',
    primaryHover: '#8f7bd6',
    terminalBg: '#1a1a2e',
    terminalText: '#d4d4d4',
    terminalKeyword: '#90caf9',
    terminalTextLine: '#e0e0e0',
    terminalAccentPurple: '#bb86fc',
    terminalAccentTeal: '#03dac6',
  },
};

export const palettes = {
  light: lightPalette,
  dark: darkPalette,
};
